/**
 * @packageDocumentation
 * @module HackerAPI.Address
 */
import { __extends } from "tslib";
import Base from "../base/base";
/**
 * A data container for an address
 * @class
 * @extends { HackerAPI.Base }
 */
var Address = /** @class */ (function (_super) {
    __extends(Address, _super);
    /**
     * Creates a new Address instance
     * @param address
     */
    function Address(_a) {
        var _b = _a === void 0 ? {} : _a, line_1 = _b.line_1, line1 = _b.line1, line_2 = _b.line_2, line2 = _b.line2, line_3 = _b.line_3, line3 = _b.line3, city = _b.city, state_province = _b.state_province, stateProvince = _b.stateProvince, country = _b.country, country_code = _b.country_code, countryCode = _b.countryCode, zip_postal_code = _b.zip_postal_code, zipPostalCode = _b.zipPostalCode, latitude = _b.latitude, longitude = _b.longitude;
        var _this = _super.call(this, {
            line1: function (k, v) { return ["line_1", v]; },
            line2: function (k, v) { return ["line_2", v]; },
            line3: function (k, v) { return ["line_3", v]; }
        }) || this;
        /**
         * @type { string }
         */
        _this.line1 = line_1 || line1;
        /**
         * @type { string }
         */
        _this.line2 = line_2 || line2;
        /**
         * @type { string }
         */
        _this.line3 = line_3 || line3;
        /**
         * @type { string }
         */
        _this.city = city;
        /**
         * @type { string }
         */
        _this.stateProvince = state_province || stateProvince;
        /**
         * @type { string }
         */
        _this.country = country;
        /**
         * @type { string }
         */
        _this.countryCode = country_code || countryCode;
        /**
         * @type { string }
         */
        _this.zipPostalCode = zip_postal_code || zipPostalCode;
        /**
         * @type { number }
         */
        _this.latitude = latitude;
        /**
         * @type { number }
         */
        _this.longitude = longitude;
        return _this;
    }
    return Address;
}(Base));
export default Address;
//# sourceMappingURL=address.js.map